// extracted by mini-css-extract-plugin
export default {"warning-msg":"WarningMessage_warning-msg__lKLN4"};